module.exports = __webpack_public_path__ + "img/quest_back.1538908b.svg";